import { ICheckPhoneVerifyResponse } from 'types/check-phone-verify';
import { api, ApiRequestConfig } from './api';

export const checkPhoneVerify = async (
  params: { regionId: string },
  config: ApiRequestConfig,
): Promise<ICheckPhoneVerifyResponse> =>
  api.get<ICheckPhoneVerifyResponse>(
    'loyalty-registration-modal/check-phone-verify',
    { regionId: params.regionId },
    config,
  );
